export default __webpack_public_path__ + "model-cardModelNlp927219.png";